<template>
  <div>
    <p style="text-transform: uppercase; margin-bottom: 0px; font-size: 12px;">{{ label }}</p>
    <p style="color: black; margin-bottom: 0px;">{{ value }}</p>
  </div>
</template>

<script>
export default {
  props: ['label', 'value'],
};
</script>
